import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { FolderIcon } from "@common/folderIcon";
import { ArrowIcon } from "@common/assets/arrowIcon";
import { NameWithCount } from "./nameWithCount";
import { Props } from "./type";
import styles from "./styles.scss";

function Input({ filter, placeholder, isOpen }: Props) {
  const { t } = useTranslation();
  const projects = filter.projects ? filter.projects : [];

  return (
    <div
      className={classNames(styles.input, {
        [styles.opened]: isOpen,
      })}
    >
      {!projects.length && <p className={styles.placeholder}>{placeholder}</p>}
      {!!projects.length && (
        <NameWithCount
          name={projects[0].name}
          nbr={projects.length - 1}
          icon={<FolderIcon className={styles.folder} />}
        />
      )}

      <ArrowIcon className={styles.toggleIcon} />
    </div>
  );
}

export { Input };
